/* jshint ignore:start */
import React from "react";
import "./VideoItem.css";
const VideoItem = ({ vitem, onSelectVItem }) => {
  return (
    <div className="card mt-2">
      <div className="card-body">
        <div className="row">
          <div
            className="col-sm-6 col-md-6 col-lg-3 col-12"
            onClick={() => onSelectVItem(vitem)}>
            <img
              src={vitem.snippet.thumbnails.high.url}
              alt="img"
              className="img-thumbnail"
              height="230rem"
              width="230rem"
            />
          </div>
          <div className="col-sm-6 col-md-6 col-lg-9 col-12">
            <h6
              onClick={() => onSelectVItem(vitem)}
              style={{ cursor: "pointer" }}>
              {vitem.snippet.title}
            </h6>
          </div>
        </div>
      </div>
    </div>
  );
};

export default VideoItem;
